import Icon, { IconProps } from './Icon';

import XIcon from '../../../assets/icons/x.svg?react';

const X: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <XIcon />
    </Icon>
  );
};

export default X;

